import ExpiredProjectsService from '@/services/ExpiredProjectsService';
import moment from 'moment';

export default {
  name: 'ExpiryProjectsList',

  props: [],

  data() {
    return {
      expiryText: 'Aby przedłużyć ważność projektu i zapewnić ciągłość działania infolinii, skontaktuj się z Twoim opiekunem handlowym.',
    };
  },

  computed: {
    isThereAnyProjectToExpire() {
      return this.expiredProjectsList && this.expiredProjectsList.length;
    },
    iconClass() {
      return `popover__icon${!this.isThereAnyProjectToExpire ? '--disabled' : ''}`;
    },
    expiredProjectsList() {
      return ExpiredProjectsService.expiredProjectsList;
    },
  },

  async created() {
    await this.getExpiredProjectsList();
  },

  methods: {
    async getExpiredProjectsList() {
      await ExpiredProjectsService.getAllExpiredProjectsList();
    },
    getDaysToExpired(expiredDate) {
      const currentDateWithoutTime = moment().startOf('day');
      const expiredDateWithoutTime = moment(expiredDate, 'YYYY-MM-DD');
      return moment.duration(expiredDateWithoutTime.diff(currentDateWithoutTime)).asDays();
    },
  },
};
